import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import LoginForm from './smart_templates/components/LoginForm';
import RegistrationForm from './smart_templates/components/RegistrationForm';

const smartTemplateGroups = {
  head: [
    { name: "ГМ", id: "brain_mri", alias: "Магнитно-резонансная томография головного мозга" },
    { name: "ВСП", id: "internal_auditory_canal", alias: "Магнитно-резонансная томография внутренних слуховых проходов" },
    { name: "Гипофиз", id: "pituitary", alias: "Магнитно-резонансная томография гипофиза" },
    { name: "НВК", id: "neurovascular_conflict", alias: "Магнитно-резонансная томография головного мозга (нейроваскулярный конфликт)" },
    { name: "Орбиты", id: "orbital_cavities", alias: "Магнитно-резонансная томография орбит" },
    { name: "ППН", id: "paranasal_sinuses", alias: "Магнитно-резонансная томография придаточных пазух носа" },
  ],
  vessels: [
    { name: "Интракраниальные артерии", id: "intracranial_arteries", alias: "Магнитно-резонансная ангиография интракраниальных артерий" },
    { name: "Экстракраниальные артерии", id: "extracranial_brachiocephalic_arteries", alias: "Магнитно-резонансная ангиография экстракраниальных брахиоцефальных артерий" },
    { name: "Вены головного мозга", id: "cerebral_veins", alias: "Магнитно-резонансная ангиография вен головного мозга" },
    { name: "Вены таза", id: "pelvic_veins", alias: "Магнитно-резонансная ангиография вен таза" },
  ],
  spine: [
    { name: "ШОП", id: "cervical_spine", alias: "Магнитно-резонансная томография шейного отдела позвоночника" },
    { name: "ГОП", id: "thoracic_spine", alias: "Магнитно-резонансная томография грудного отдела позвоночника" },
    { name: "ПКОП + Копчик", id: "lumbar_spine", alias: "Магнитно-резонансная томография пояснично-крестцового отдела позвоночника" },
    { name: "КПС", id: "sacroiliac_joint", alias: "Магнитно-резонансная томография крестцово-подвздошных сочленений" },    
  ],
  joints: [
    { name: "ВНЧС", id: "temporomandibular_joint", alias: "Магнитно-резонансная томография височно-нижнечелюстных суставов" },
    { name: "Грудино-ключичное сочленение", id: "sternoclavicular_joint", alias: "Магнитно-резонансная томография грудино-ключичного сочленения" },
    { name: "Плечевой сустав", id: "shoulder_joint", alias: "Магнитно-резонансная томография плечевого сустава" },
    { name: "Локтевой сустав", id: "elbow_joint", alias: "Магнитно-резонансная томография локтевого сустава" },
    { name: "Кисть", id: "hand_joint", alias: "Магнитно-резонансная томография кисти" },
    { name: "Лучезапястный сустав", id: "wrist_joint", alias: "Магнитно-резонансная томография лучезапястного сустава" },
    { name: "Тазобедренные суставы", id: "hip_joints", alias: "Магнитно-резонансная томография тазобедренных суставов" },
    { name: "Коленный сустав", id: "knee_joint", alias: "Магнитно-резонансная томография коленного сустава" },
    { name: "Голеностопный сустав", id: "ankle_joint", alias: "Магнитно-резонансная томография голеностопного сустава" },
    { name: "Стопа", id: "foot_joint", alias: "Магнитно-резонансная томография стопы" },
  ],
  soft_tissues: [
    { name: "Молочные железы", id: "breast_tissue", alias: "Магнитно-резонансная томография молочных желез" },
    { name: "Мягкие ткани шеи", id: "soft_tissues_neck", alias: "Магнитно-резонансная томография мягких тканей шеи" },
    { name: "Мягкие ткани любой области", id: "soft_tissues_any_region", alias: "Магнитно-резонансная томография мягких тканей" },
    { name: "Наружные половые органы (муж)", id: "male_external_genital_organs", alias: "Магнитно-резонансная томография наружных половых органов" },
    { name: "Плечевое сплетение", id: "brachial_plexus", alias: "Магнитно-резонансная томография плечевого сплетения" },
  ],
  chest: [
    { name: "Средостение", id: "mediastinum", alias: "Магнитно-резонансная томография средостения" },
    { name: "Сердце", id: "heart", alias: "Магнитно-резонансная томография сердца" },
  ],
  pelvis: [
    { name: "Мужской таз", id: "male_pelvis", alias: "Магнитно-резонансная томография органов малого таза" },
    { name: "Женский таз", id: "female_pelvis", alias: "Магнитно-резонансная томография органов малого таза" },
    { name: "Плацента", id: "placenta", alias: "Магнитно-резонансная томография плаценты" },
  ],
  abdominal: [
    { name: "ОБП + ОЗП", id: "retroperitoneal_space", alias: "Магнитно-резонансная томография органов брюшной полости и забрюшинного пространства" },
  ],
  instruction: [
    { name: "Нажми меня. Затем кнопку 'Норма' вверху открывшейся страницы", id: "main_instruction", alias: "Инструкция" },
  ]
};

// Отображаемые названия групп
const groupLabels = {
  head: "Голова",
  vessels: "Сосуды",
  spine: "Позвоночник",
  joints: "Суставы",
  soft_tissues: "Мягкие ткани",
  chest: "Грудная область",
  pelvis: "Тазовая область",
  abdominal: "Абдоминальная область",
  instruction: "ИНСТРУКЦИЯ",
};

// Функция для получения alias по templateId
export const getTemplateAlias = (templateId) => {
  for (const group of Object.values(smartTemplateGroups)) {
    const template = group.find(t => t.id === templateId);
    if (template) {
      return template.alias;
    }
  }
  return null;
};

const HomePage = () => {
  const [openedGroup, setOpenedGroup] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('access_token'));
  const [showRegister, setShowRegister] = useState(false);
  const navigate = useNavigate();

  const toggleGroup = (groupName) => {
    setOpenedGroup((prev) => (prev === groupName ? null : groupName));
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setIsLoggedIn(false);
  };

  if (!isLoggedIn) {
    return showRegister ? (
      <RegistrationForm
        onRegister={() => { setIsLoggedIn(true); setShowRegister(false); }}
        onSwitchToLogin={() => setShowRegister(false)}
      />
    ) : (
      <LoginForm
        onLogin={() => setIsLoggedIn(true)}
        onSwitchToRegister={() => setShowRegister(true)}
      />
    );
  }

  return (
    <div className="home-container">
      <h1 className="main-title">Умные шаблоны для МРТ описаний</h1>
      <button onClick={handleLogout} style={{ position: 'absolute', top: 16, right: 16 }}>Выйти</button>
      <div className="button-group">
        {/* Кнопки первого уровня */}
        {Object.keys(smartTemplateGroups).map((groupKey) => (
          <React.Fragment key={groupKey}>
            <button
              className="main-button"
              onClick={() => toggleGroup(groupKey)}
              style={{ 
                backgroundColor: groupKey === 'instruction' 
                  ? '#ffe066' // ярко-желтый для инструкции
                  : (openedGroup === groupKey ? '#2980b9' : undefined),
                color: groupKey === 'instruction' ? '#7c5c00' : undefined, // тёмный текст для желтого
                fontWeight: groupKey === 'instruction' ? 'bold' : undefined
              }}
            >
              {groupLabels[groupKey] || groupKey}
            </button>
            {/* Вложенные шаблоны */}
            {openedGroup === groupKey && (
              <div className="sub-button-group">
                {smartTemplateGroups[groupKey].map((template) => (
                  <button
                    key={template.id}
                    className="sub-button"
                    onClick={() => navigate(`/smart_templates/${template.id}`, { state: { smartTemplateDescription: template.name } })}
                    style={groupKey === 'instruction' ? {
                      backgroundColor: '#fff3bf', // светло-желтый для подгруппы
                      color: '#7c5c00',
                      fontWeight: 'bold'
                    } : {}}
                  >
                    {template.name}
                  </button>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
